<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1" stepTitle="套餐及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">新增套餐与价格</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm"
                        :label-col="currentFormLayout.labelCol"
                        :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品规格" required>
              <template v-if="specList&&specList.length>0">
                <div class="model-content" v-for="(item,index) in specList" :key="index">
                  <div class="content">
                    <a-select v-model="item.name" allowClear :disabled="proSource!=0" placeholder="请选择"
                              style="max-width:400px;">
                      <a-select-option v-for="itemNorm in programList" :key="itemNorm.code" :value="itemNorm.name">
                        {{ itemNorm.name }}
                      </a-select-option>
                    </a-select>
                    <a class="ml15" :disabled="specList.length === 1||proSource!=0" @click="deleteItem(item)">删除</a>
                  </div>
                  <div class="content-flex">
                    <div class="content-box" v-for="(SonItem,SonIndex) in item.valueList" :key="SonIndex">
                      <div class="content-row">
                        <a-checkbox :disabled="SonItem.name==''||proSource!=0" v-model="SonItem.isTrue"
                                    @change="onIsTrueChange(index,SonIndex)"></a-checkbox>
                        <div class="check-input">
                          <a-input :disabled="item.name==''||proSource!=0" v-model="SonItem.name"
                                   @change="onFocusEvent(index,SonIndex)" @blur="onBlurvent(index,SonIndex)"
                                   placeholder="请输入"/>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </template>
              <a-button @click="addSpec" style="margin-right:15px;" :disabled="proSource!=0">
                <a-icon type="plus"/>
                添加新规格
              </a-button>
              <a-button @click="onGenerateSpec" :disabled="specList.length==0||proSource!=0">
                <a-icon type="plus"/>
                生成规格
              </a-button>
            </a-form-model-item>
            <a-form-model-item label="价格与库存" required>
              <table class="table-model">
                <thead>
                <tr>
                  <th v-for="(item, index) in specGridHead" :key="index">{{ item }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in ruleForm.priceDtoList" :key="index">
                  <td v-for="(subsetItem,subsetIndex) in item.normParamList" :key="subsetIndex">
                    <div>{{ subsetItem.value }}</div>
                  </td>
                  <td>
                    <a-form-model-item :prop="'priceDtoList.' + index + '.priceDto.mfAuditPrice'"
                                       :rules="[{ required: true, message: '请输入金额', trigger: 'blur'},
                      { pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message:'金额有误',trigger: 'blur'}]">
                      <a-input :disabled="proSource!=0" v-model="item.priceDto.mfAuditPrice"
                               placeholder="请输入"></a-input>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item :prop="'priceDtoList.' + index + '.priceDto.advicePrice'"
                                       :rules="[{ required: true, message: '请输入金额', trigger: 'blur'},
                      { pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message:'金额有误',trigger: 'blur'},
                      { validator: checkAdvicePrice, trigger: 'blur' }
                      ]">
                      <a-input :disabled="proSource!=0" v-model="item.priceDto.advicePrice"
                               placeholder="请输入"></a-input>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item :prop="'priceDtoList.' + index + '.priceDto.commissionPrice'"
                                       :rules="[{ pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '金额有误',trigger: 'blur'}]">
                      <a-input :disabled="proSource!=0" v-model="item.priceDto.commissionPrice"
                               placeholder="请输入"></a-input>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item :prop="'priceDtoList.' + index + '.priceDto.marketPrice'"
                                       :rules="[{ pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message:'金额有误',trigger: 'blur'}]">
                      <a-input :disabled="proSource!=0" v-model="item.priceDto.marketPrice"
                               placeholder="请输入"></a-input>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item :prop="'priceDtoList.' + index + '.priceDto.purchasePrice'"
                                       :rules="[{ pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message:'金额有误',trigger: 'blur'}]">
                      <a-input :disabled="proSource!=0" v-model="item.priceDto.purchasePrice"
                               placeholder="请输入"></a-input>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item :prop="'priceDtoList.' + index + '.priceDto.stock'"
                                       :rules="[{ pattern: /^[0-9]\d{0,5}$/, message:'库存有误',trigger: 'blur'}]">
                      <a-input :disabled="proSource!=0" v-model="item.priceDto.stock" placeholder="请输入"></a-input>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item>
                      <a-input :disabled="proSource!=0" v-model="item.commodityOptionNo" placeholder="请输入"></a-input>
                    </a-form-model-item>
                  </td>
                </tr>
                </tbody>
              </table>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">提交
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import PublishPro from '../components/PublishPro'

export default {
  name: 'DepartmentPriceSet',
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      submitLoading: false,
      submitFormData: '',
      programList: [],
      specList: [
        {
          name: undefined,
          valueList: [
            {
              isTrue: false,
              name: ''
            }
          ]
        }
      ],
      specGridHeadPreset: ['同行价', '销售价', '佣金', '市场价', '采购价', '库存', '商家编码'],
      ruleForm: {
        proId: this.$route.query.proId, //产品ID
        priceDtoList: [
          //   {
          //   "normParamList": [
          //     {
          //       "name": "型号",
          //       "value": "大"
          //     },
          //     {
          //       "name": "微辣",
          //       "value": "特辣"
          //     }
          //   ],
          //   priceDto:{
          //     mfAuditPrice:"10",
          //     advicePrice:"20",
          //     commissionPrice:"2",
          //     marketPrice:"25",
          //     purchasePrice:"8",
          //     stock:"100",
          //     commodityOptionNo:"AS11111111",
          //   }
          // },
          // {
          //   "normParamList": [
          //     {
          //       "name": "型号",
          //       "value": "大"
          //     },
          //     {
          //       "name": "微辣",
          //       "value": "微辣"
          //     }
          //   ],
          //     priceDto:{
          //     mfAuditPrice:"10",
          //     advicePrice:"20",
          //     commissionPrice:"2",
          //     marketPrice:"25",
          //     purchasePrice:"8",
          //     stock:"100",
          //     commodityOptionNo:"AS11111111",
          //   }
          //   },
          // {
          //   "normParamList": [
          //     {
          //       "name": "型号",
          //       "value": "小"
          //     },
          //     {
          //       "name": "微辣",
          //       "value": "特辣"
          //     }
          //   ],
          //     priceDto:{
          //     mfAuditPrice:"10",
          //     advicePrice:"20",
          //     commissionPrice:"2",
          //     marketPrice:"25",
          //     purchasePrice:"8",
          //     stock:"100",
          //     commodityOptionNo:"AS11111111",
          //   }
          //   },
          // {
          //   "normParamList": [
          //     {
          //       "name": "型号",
          //       "value": "小"
          //     },
          //     {
          //       "name": "微辣",
          //       "value": "微辣"
          //     }
          //   ],
          //   priceDto:{
          //     mfAuditPrice:"10",
          //     advicePrice:"20",
          //     commissionPrice:"2",
          //     marketPrice:"25",
          //     purchasePrice:"8",
          //     stock:"100",
          //     commodityOptionNo:"AS11111111",
          //   }
          // }
        ]
      }

    }
  },
  mounted() {
    this.getProCommodityNorm()
    this.getCommoditInfo()
    let list1 = [{ name: 1, value: 1 }, { name: 2, value: 2 }]
    let list2 = [{ name: 1, value: 1 }, { name: 2, value: 2 }]
    this.getLogUtils().logWithTag('标胶', this.judgeResultFun(list1, list2))
  },
  computed: {
    specGridHead() {
      return this.specList.map(item => item.name).concat(this.specGridHeadPreset)
    }
  },
  methods: {
    checkAdvicePrice(rule, value, callback) {
      this.getLogUtils().logWithTag('rule', rule)
      let index = Number(rule.field.split('.')[1])
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.priceDtoList[index].priceDto.mfAuditPrice)) {
          callback(new Error('须大于同行价'))
        } else {
          callback()
        }
      }, 1000)
    },
    // 回显表格数据
    getList() {
      let result = []
      this.ruleForm.priceDtoList.forEach(item => {
        item.normParamList.forEach(property => {
          let target = result.find(spec => {
            return spec.name === property.name
          })
          if (!target) {
            result.push({
              name: property.name,
              valueList: [{ name: property.value, isTrue: true }]
            })
          } else {
            if (!target.valueList.find(value => value.name === property.value)) {
              target.valueList.push({ name: property.value, isTrue: true })
            }
          }
        })
      })
      this.getLogUtils().logWithTag('result', result)
      this.specList = result
      this.getLogUtils().logWithTag('specList', this.specList)
    },
    // 添加规格
    addSpec() {
      // 最多添加三个
      if (this.specList.length < 3) {
        this.specList.push({
          name: undefined,
          valueList: [
            {
              name: '',
              isTrue: false
            }
          ]
        })
      }
      this.getLogUtils().logWithTag('this.specList', this.specList)
    },
    // 删除规格
    delSpec(index) {
      this.specList.splice(index, 1)
    },
    // 添加规格值
    addSpecValue(index) {
      // 最多添加五个
      if (this.specList[index].valueList.length < 5) {
        this.specList[index].valueList.push({
          name: '',
          isTrue: false
        })
      }
    },
    // 删除规格值
    delSpecValue(index, valueIndex) {
      this.specList[index].valueList.splice(valueIndex, 1)
    },
    // 删除规格
    deleteItem(item) {
      let index = this.specList.indexOf(item)
      if (index !== -1) {
        this.specList.splice(index, 1)
      }
    },
    // 获取焦点事件触发新增规格输入
    onFocusEvent(index, SonIndex) {
      if (this.specList[index].valueList.length < 5) {
        let flag = false
        this.specList[index].valueList.forEach(item => {
          if (item.name == '') {
            flag = true
          }
        })
        if (!flag) {
          this.specList[index].valueList.push({
            isTrue: false,
            name: ''
          })
        }
      }
    },
    // 失去焦点后 选中checkbox
    onBlurvent(index, SonIndex) {
      let flag = false
      let textStr = this.specList[index].valueList[SonIndex].name
      if (!textStr) {
        return
      }
      let list = this.specList[index].valueList
      this.specList[index].valueList.forEach((item, idx) => {
        this.getLogUtils().logWithTag(item.name)
        if (idx < SonIndex) {
          if (item.name == textStr) {
            flag = true
          }
        }
      })
      if (!flag) {
        this.specList[index].valueList[SonIndex].isTrue = true
      } else {
        this.$message.error('请勿重复输入')
      }
    },
    onIsTrueChange(index, SonIndex) {
      if (this.specList[index].valueList.length > 0) {
        this.specList[index].valueList.splice(SonIndex, 1)
      }
    },
    // 生成规格
    onGenerateSpec() {
      this.getLogUtils().logWithTag('this.specList', this.specList)
      // 过滤空白的规格
      let normBlankList = this.specList.map(item => {
        return {
          name: item.name,
          valueList: item.valueList.filter(value => value.name)
        }
      })
      this.getLogUtils().logWithTag('normBlankList', normBlankList)
      // 验证选择或者输入的值是否合理
      if (this.verificationData(normBlankList)) {
        // 获取规格数据
        this.ruleForm.priceDtoList = this.generate(normBlankList).map(item => {
          this.getLogUtils().logWithTag('数据', item)
          return {
            normParamList: item,
            commodityOptionNo: '',
            priceDto: {
              mfAuditPrice: '',
              advicePrice: '',
              commissionPrice: '',
              marketPrice: '',
              purchasePrice: '',
              stock: ''
            }
          }
        })
        this.getLogUtils().logWithTag('priceDtoList', this.ruleForm.priceDtoList)
      }
    },
    judgeResultFun(arr1, arr2) {
      let flag = true
      if (arr1.length !== arr2.length) {
        flag = false
      } else {
        arr1.forEach(item => {
          if (JSON.stringify(arr2).indexOf(JSON.stringify(item)) === -1) {
            flag = false
          }
        })
      }
      return flag
    },
    verificationData(list) {
      let flag1 = false
      let flag2 = false
      let flag3 = false
      list.forEach(item => {
        if (!item.name) {
          flag1 = true
        }
        if (item.valueList.length == 0) {
          flag2 = true
        }
        item.valueList.forEach(item1 => {
          if (!item1.isTrue) {
            flag3 = true
          }
        })
      })
      if (flag1) {
        this.$message.error('请选择规格')
        return false
      }
      if (flag2) {
        this.$message.error('请输入规格名称')
        return false
      }
      if (flag3) {
        this.$message.error('请勿重复输入')
        return false
      }
      if (this.arrSet(list)) {
        this.$message.error('请勿选择重复规格')
        return false
      }
      return true
    },
    // 判断数组是否重复
    arrSet(arr) {
      let flag = false
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].name === arr[j].name) {
            this.getLogUtils().logWithTag('重名了！！')
            flag = true
          }
        }
      }
      return flag
    },
    // 生成规格的全排列函数
    generate(arr) {
      if (arr.length < 1) {
        return []
      } else if (arr.length < 2) {
        let result = []
        let item = arr[0]
        item.valueList.map(value => {
          result.push([{
            name: item.name,
            value: value.name
          }])
        })
        return result
      } else {
        return arr.reduce((acc, item) => {
          return mix(acc, item)
        })
      }

      function mix(item1, item2) {
        var arr1 = Array.isArray(item1.valueList) ? item1.valueList : item1
        var arr2 = item2.valueList
        var result = []
        for (let i = 0; i < arr1.length; i++) {
          for (let j = 0; j < arr2.length; j++) {
            let item = []
            if (Array.isArray(arr1[i])) {
              item = item.concat(arr1[i])
              item.push({
                name: item2.name,
                value: arr2[j].name
              })
            } else {
              item.push({
                name: item1.name,
                value: arr1[i].name
              })
              item.push({
                name: item2.name,
                value: arr2[j].name
              })
            }
            result.push(item)
          }
        }
        return result
      }

    },
    // 获取套餐的规格型号的接口
    getProCommodityNorm() {
      this.getHttpServices().getBaseService().get('base/sysCode/getProCommodityNorm').then(res => {
        this.getLogUtils().logWithTag('getProCommodityNorm', res)
        this.programList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSubmit() {
      this.getLogUtils().logWithTag(JSON.stringify(this.ruleForm.priceDtoList))
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitFormData', this.submitFormData)
      this.getHttpServices().getProService().post('product/commodity/editProCommodityOption', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('套餐与价格新增成功')
        this.getCommoditInfo()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取套餐的规格型号的接口
    getCommoditInfo() {
      this.getHttpServices().getProService().get('product/commodity/findProCommodityOption?proId=' + this.proId).then(res => {
        this.getLogUtils().logWithTag('getCommoditInfo', res)
        if (res && res.length > 0) {
          this.ruleForm.priceDtoList = res
          this.getList()
          this.getLogUtils().logWithTag('specList', this.specList)
          this.specList.forEach(Item => {
            if (Item.valueList.length < 5) {
              Item.valueList.push({ name: '', isTrue: false })
            }
          })
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      flex-grow: 1;
      width: 400px;

      .content-flex {
        display: flex;
        flex-wrap: wrap;

        .content-box {
          display: flex;
          align-items: center;

          .content-row {
            display: flex;
            align-items: center;
            margin-right: 10px;

            .check-input {
              margin-left: 5px;
              max-width: 200px;
            }
          }

        }
      }
    }

    .table-model {
      thead {
        border-bottom: 1px solid #e9e9e9;
        background-color: #fafafa;

        tr {
          th {
            padding: 4px;
            min-width: 70px;
          }
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #e9e9e9;

          td {
            min-width: 70px;
          }
        }
      }

      .ant-form-item {
        margin-top: 20px;
      }
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.ml15 {
  margin-left: 15px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>